import { type FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BsFileEarmarkPlus, BsTrash } from 'react-icons/bs';
import { Draggable } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom';

import { type RootState } from '@editor2/reducers/root';
import {
	deletePageFromPageGroup,
	deletePageFromChapter
} from '@editor2/reducers/editor/editorSlice';
import AddPageModal from '@editor2/components/AddPageModal';
import { pageBlock } from '@editor2/containers/TableOfContentsPage/styles';

interface Props {
	pageId: string;
	index: number;
	pageGroupId?: string;
	chapterId: string;
	courseId: number;
}

const TableOfContentsPage: FC<Props> = (props) => {
	const { pageId, index, pageGroupId, chapterId, courseId } = props;

	const dispatch = useDispatch();
	const { pages } = useSelector((state: RootState) => state.courses[courseId]);
	const page = pages.entities[pageId];

	const [isAddPageModalShown, setAddPageModalShown] = useState(false);

	const onAddPageClick = () => {
		setAddPageModalShown(true);
	};

	const onDeletePageClick = () => {
		if (window.confirm(`Are you sure to delete "${page.name}" page?`)) {
			if (pageGroupId) {
				dispatch(deletePageFromPageGroup({ pageGroupId, pageId, courseId }));
			} else {
				dispatch(deletePageFromChapter({ chapterId, pageId, courseId }));
			}
		}
	};

	const isNormal = page.page_type === 'normal';

	const pageLink =
		`/courses/${courseId}/chapters/${chapterId}` +
		(pageGroupId ? `/page_groups/${pageGroupId}` : '') +
		`/pages/${pageId}`;

	return (
		<div className={pageBlock}>
			<Draggable draggableId={pageId} index={index}>
				{(provided) => (
					<div
						className="pageContainer"
						ref={provided.innerRef}
						{...provided.draggableProps}
						{...provided.dragHandleProps}>
						<div className="pageMenu">
							<BsFileEarmarkPlus onClick={() => onAddPageClick()} />
							<BsTrash onClick={() => onDeletePageClick()} />
						</div>
						<Link to={pageLink} className={isNormal ? '' : 'notNormalPage'}>
							{`${page.page_number || ''} ${page.name}`}
						</Link>

						{isAddPageModalShown && (
							<AddPageModal
								chapterId={chapterId}
								pageGroupId={pageGroupId}
								index={index + 1}
								onHide={() => setAddPageModalShown(false)}
								isShown={isAddPageModalShown}
								courseId={courseId}
							/>
						)}
					</div>
				)}
			</Draggable>
		</div>
	);
};

export default TableOfContentsPage;
